import type { FormikValueAdapter } from 'utils/formik/FormikValueAdapter';

export const formikInputArrayToCsv: FormikValueAdapter<string[], string> = {
  toInput: (value) => (value ? value.split(',') : []),
  toModel: (value) => value.join(','),
};
